import { Survey } from '@/services/surveys-service/surveys-service.types';

export const generateDataSource = (data: Survey[]): Survey[] => {
  return data?.map((element) => ({
    key: element.id,
    ...element,
  }));
};
